/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.3.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */

import { __extends } from 'tslib';
import { OutputStream } from './OutputStream.js';

/**
 * @module ByteArrayOutputStream
 * @author nuintun
 * @author Kazuhiko Arase
 */
var ByteArrayOutputStream = /*#__PURE__*/ (function (_super) {
  __extends(ByteArrayOutputStream, _super);
  function ByteArrayOutputStream() {
    var _this = (_super !== null && _super.apply(this, arguments)) || this;
    _this.bytes = [];
    return _this;
  }
  ByteArrayOutputStream.prototype.writeByte = function (byte) {
    this.bytes.push(byte);
  };
  ByteArrayOutputStream.prototype.writeInt16 = function (byte) {
    this.bytes.push(byte, byte >>> 8);
  };
  ByteArrayOutputStream.prototype.toByteArray = function () {
    return this.bytes;
  };
  return ByteArrayOutputStream;
})(OutputStream);

export { ByteArrayOutputStream };
